/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, PerspectiveCamera } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/3chairs.glb");
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-19.85, 0, 5.32]} scale={0.33}>
        <group position={[-196.49, 0, -301.93]}>
          <group position={[14.09, 0, 348.25]} rotation={[0, 0.26, 0]}>
            <group
              position={[122.71, 40.37, 36.45]}
              rotation={[-Math.PI / 2, 0, 0]}
            >
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(2)-Saba_Italia_New_York_mat_2__mtl_4"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(2)-Saba_Italia_New_York_mat_2__mtl_4"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(2)-Saba_Italia_New_York_mat_2__mtl_3"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(2)-Saba_Italia_New_York_mat_2__mtl_3"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(2)-Saba_Italia_New_York_mat_2__mtl_2"
                  ].geometry
                }
                material={materials.Saba_Italia_New_York_mat_2__mtl_2}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(2)-Saba_Italia_New_York_mat_2__mtl_1"
                  ].geometry
                }
                material={materials.Saba_Italia_New_York_mat_2__mtl_1}
              />
            </group>
            <group
              position={[245.49, 40.37, 36.45]}
              rotation={[-Math.PI / 2, 0, 0]}
            >
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_4"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_4"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_3"
                  ].geometry
                }
                material={materials.Saba_Italia_New_York_mat_3__mtl_3}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_2"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_2"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_1"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(3)-Saba_Italia_New_York_mat_3__mtl_1"
                  ].material
                }
              />
            </group>
            <group
              position={[368.27, 40.37, 36.45]}
              rotation={[-Math.PI / 2, 0, 0]}
            >
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_4"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_4"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_3"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_3"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_2"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_2"
                  ].material
                }
              />
              <mesh
                castShadow
                receiveShadow
                geometry={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_1"
                  ].geometry
                }
                material={
                  nodes[
                    "Saba_Italia_New_York_mat(4)-Saba_Italia_New_York_mat_4__mtl_1"
                  ].material
                }
              />
            </group>
          </group>
        </group>
      </group>
      <PerspectiveCamera
        makeDefault={false}
        far={132.73}
        near={0}
        fov={34.52}
        position={[-58.8, 0.3, 16.39]}
        rotation={[-0.36, 0.75, 0.25]}
      />
    </group>
  );
}

useGLTF.preload("3chairs.glb");
